import { useCallback } from "react";
import { useLang } from "./useSiteInfo";
import { defaultLang } from "@/lib/getSite";

export default function useLangData<T extends { lang: string | number }>() {
  const lang = useLang();

  return useCallback(
    (key: string, defaultData: string, langData?: T[]) => {
      if (!lang) return defaultData;

      if (Number(lang) === defaultLang) return defaultData;

      const data = langData?.find((item) => Number(item.lang) === Number(lang));

      return (data as Record<string, string>)?.[key] || defaultData;
    },
    [lang]
  );
}
